"use client";
import { useEffect, useState } from 'react';
import { IconsType } from '@/types/nearbyMap';

export const useMapIcons = () => {
  const [icons, setIcons] = useState<IconsType | null>(null);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      import('leaflet').then((L) => {
        const IconDefault = L.Icon.Default as any;
        if (IconDefault.prototype._getIconUrl) {
          delete IconDefault.prototype._getIconUrl;
        }

        L.Icon.Default.mergeOptions({
          iconRetinaUrl: '/images/icons/job-location.svg',
          iconUrl: '/images/icons/job-location.svg',
          shadowUrl: null,
        });

        const userIcon = new L.Icon({
          iconUrl: '/images/icons/user-location.png',
          iconSize: [40, 40],
          iconAnchor: [20, 20],
        });

        const jobIcon = new L.Icon({
          iconUrl: '/images/icons/job-location.svg',
          iconSize: [36, 45],
          iconAnchor: [18, 45],
        });

        setIcons({ userIcon, jobIcon });
      });
    }
  }, []);

  return icons;
};
